import { render, staticRenderFns } from "./BookingEventDetails.vue?vue&type=template&id=7dae44bc&scoped=true&"
import script from "./BookingEventDetails.vue?vue&type=script&lang=js&"
export * from "./BookingEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingEventDetails.vue?vue&type=style&index=0&id=7dae44bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae44bc",
  null
  
)

export default component.exports